import styled from 'styled-components'
import { BqButton, BqIcon } from '@beeq/react'

export const StyledBqButton = styled(BqButton)`
  &::part(button) {
    width: var(--bq-spacing-l);
    height: var(--bq-spacing-l);
    border-radius: var(--bq-radius--s);
  }
`

export const StyledBqIcon = styled(BqIcon)`
  --bq-icon--size: 16px;
`
